let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8TbEy")).then(() => parcelRequire('khga6'));